import { EditorUiContext } from "@/components/EditorPageLayout/contexts/EditorUIContext/context";
import { useContext } from "react";

export const useEditorUI = () => {
  return useContext(EditorUiContext);
};
